import confetti from 'canvas-confetti';

interface ConfettiConfiguration {
    particleCount: number;
    angle: number;
    spread: number;
    shapes?: confetti.Shape[];
    flat?: boolean;
    ticks?: number;
    scalar?: number;
    startVelocity?: number;
    gravity?: number;
    origin: { x: number; y: number };
    colors: string[];
    zIndex: number;
}

const DEFAULT_CONFETTI_COLORS = ['#EBD6B1'];

export const CELEBRATION_CONFETTI_CONFIGURATION = [
    // BOTTOM LEFT
    {
        particleCount: 300,
        angle: 60,
        spread: 70,
        origin: { x: 0, y: 1 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // TOP LEFT
    {
        particleCount: 300,
        angle: 350,
        spread: 70,
        origin: { x: -0.1, y: -0.1 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // BOTTOM RIGHT
    {
        particleCount: 300,
        angle: 130,
        spread: 70,
        origin: { x: 1, y: 1 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // TOP RIGHT
    {
        particleCount: 300,
        angle: 190,
        spread: 70,
        origin: { x: 1.1, y: -0.1 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // TOP
    {
        particleCount: 300,
        angle: 270,
        spread: 70,
        origin: { x: 0.5, y: -0.6 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // BOTTOM
    {
        particleCount: 300,
        angle: 90,
        spread: 70,
        origin: { x: 0.5, y: 1.1 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
];

/* eslint-disable import-x/no-named-as-default-member -- shapeFromText is not a named ESM export, only available on the default export */
const getSadConfettiShapes = (): confetti.Shape[] => [
    confetti.shapeFromText('😢'),
    confetti.shapeFromText('😭'),
    confetti.shapeFromText('☹️'),
];
/* eslint-enable import-x/no-named-as-default-member */

export const SAD_CONFETTI_CONFIGURATION = [
    // TOP - middle
    {
        particleCount: 200,
        flat: true,
        startVelocity: 50,
        gravity: 1.5,
        scalar: 1.5,
        ticks: 1000,
        angle: 270,
        spread: 200,
        shapes: getSadConfettiShapes(),
        origin: { x: 0.5, y: -0.9 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // TOP - left
    {
        particleCount: 200,
        flat: true,
        startVelocity: 50,
        gravity: 1.5,
        scalar: 1.5,
        ticks: 1000,
        angle: 270,
        spread: 200,
        shapes: getSadConfettiShapes(),
        origin: { x: 0, y: -0.9 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
    // TOP - right
    {
        particleCount: 200,
        flat: true,
        startVelocity: 50,
        gravity: 1.5,
        scalar: 1.5,
        ticks: 1000,
        angle: 270,
        spread: 200,
        shapes: getSadConfettiShapes(),
        origin: { x: 1, y: -0.9 },
        colors: DEFAULT_CONFETTI_COLORS,
        zIndex: 10000,
    },
];

export const launchConfetti = (configurations: ConfettiConfiguration[]): void => {
    configurations.forEach((configuration) => {
        confetti(configuration);
    });
};
